
import XButton from 'vux/src/components/x-button/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'


export default {
components: {
XButton,
XHeader
},
data () {
return {



}
},
created() {

},
mounted(){

},
methods:{

}
}



// WEBPACK FOOTER //
// ./src/pages/useState.vue